module.exports = __webpack_public_path__ + "img/software-icon.8bc7a389.png";